import { useState } from 'react';
import {
  Button,
  CloseButton,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import { datadogRum } from '@datadog/browser-rum';
import type { CustomerType } from '@customTypes/customer';
import { toast } from 'react-toastify';
import api from '@services/api';
import CustomDialogBackdrop from '@components/CustomDialogBackdrop';


type Props = {
  customer: CustomerType;
  handleClose: () => void;
  afterSubmit: () => void;
};

const ConfirmDisableDialog = ({ customer, handleClose, afterSubmit }: Props) => {
  const [loading, setLoading] = useState(false);

  const onDeleteClick = async () => {
    setLoading(true);

    try {
      const response = await api.delete(`/customer/${customer.id}`);

      if (response.status === 200) {
        toast.success('Cliente desabilitado com sucesso.');
        afterSubmit();
      }
    } catch (error) {
      toast.error('Erro ao desabilitar cliente. Tente novamente!');
      datadogRum.addError(new Error('Fail to disable customer'), {
        error,
        customerId: customer.id,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <CustomDialogBackdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Tem certeza que deseja excluir o cliente
                {' '}
                {customer.name}
                ?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text color="fg.muted">
                Esta ação não pode ser desfeita. Qualquer item que faça referência
                a este portfólio perderá essa associação.
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" disabled={loading}>Cancelar</Button>
              </Dialog.ActionTrigger>
              <Button bg="red.500" color="white" onClick={onDeleteClick} loading={loading}>
                Desabilitar
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmDisableDialog;
